import gql from '@zenbusiness/application-commons-utils/gql';

export const GET_LENDING_PROSPECTS = gql`
  query lendingProspects($filter: LendingProspectFilter!, $pagination: OffsetPageInput) {
    lendingProspects(filter: $filter, pagination: $pagination) {
      pageInfo {
        page
        pageSize
        pageCount
        totalCount
        hasNextPage
      }
      data {
        businessEntityUuid
        lendingProspectUuid
        isPreSelected
        businessName
        phone
        email
        createdDatetime
        updatedDatetime
      }
    }
  }
`;
